import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseChartDirective } from 'ng2-charts';
import { CommonModule, DatePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgModule } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ApiservicesService } from '../../../Services/Apis/apiservices.service';
import { SelectionModel } from '@angular/cdk/collections';
import { ToastService } from '../../../Services/toast/toast.service';
import { ToastComponent } from '../../../components/toast/toast.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateDirective } from '../../../components/Utilites/Directives/translate.directive';
import { forkJoin } from 'rxjs';

Chart.register(...registerables);

export interface PeriodicElement {
  index: number,
  id: string;
  name: number;
  status: number;
  tillDate: string;
}

@Component({
  selector: 'app-attendance',
  templateUrl: './classesview.component.html',
  styleUrls: ['./classesview.component.scss'],
  imports: [
    CommonModule,
    MatCheckboxModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatProgressBarModule,
    MatListModule,
    MatDatepickerModule,
    MatTableModule,
    MatFormFieldModule,
    BaseChartDirective,
    ToastComponent,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    TranslateDirective
  ],
  standalone: true
})
export class ClassesviewComponent implements OnInit {
  displayedColumns: string[] = ['select', 'id', 'name', 'status'];
  attendanceData: any[] = [];
  presentData: any[] = [];
  absenteesData: any[] = [];
  showPresent: boolean = true;
  classesData: any;
  // chart: any;
  StudentList: any;
  pipe = new DatePipe('en-US');
  showToast: boolean = false;
  selection = new SelectionModel<PeriodicElement>(true, []);
  studentsattendancedetailschart: any;
  isLoadingResults = true;
  isRateLimitReached = false;
  isChecked = false;
  selectedDate: Date = new Date();
  @ViewChild('attendanceChart') attendanceChart!: ElementRef<HTMLCanvasElement>;
  chart!: Chart;

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private apiservice: ApiservicesService,
    private toast: ToastService) {
    this.classesData = history.state?.data;
  }

  ngOnInit() {
    this.selectedDate = this.classesData?.date;
    this.loadAttendanceData();
  }

  // fetchAttendanceData() {
  //   const apiData = [
  //     { id: 301, name: 'Akula Lavanya', tillDate: 70 },
  //     { id: 302, name: 'Devane Vaishnavi', tillDate: 90 },
  //     { id: 303, name: 'Student 3', tillDate: 40 }
  //   ];
  //   this.attendanceData = apiData.map((student) => ({
  //     ...student,
  //     status: 'Present',
  //   }));
  //   this.updateAttendanceLists();
  // }

  toggleStatus(element: any, status: any) {
    if (status === 'ABSENT' || status === false) {
      element.status = 'ABSENT';
    } else if (status === 'PRESENT' || status === true) {
      element.status = 'PRESENT';
    }
    // element.status = element.status === 'ABSENT' ? 'Present' : 'ABSENT';
    // this.updateAttendanceLists();  
  }

  updateAttendanceLists() {
    this.presentData = this.attendanceData.filter(
      (student) => student.status === 'PRESENT'
    );
    this.absenteesData = this.attendanceData.filter(
      (student) => student.status === 'ABSENT'
    );
  }

  // onDateChange(event: any) {
  //   if (event.value) {
  //     this.selectedDate = event.value;
  //   }
  // }

  // previousDate() {
  //   const previousDay = new Date(this.selectedDate);
  //   previousDay.setDate(this.selectedDate.getDate() - 1);
  //   this.selectedDate = previousDay;
  // }

  // nextDate() {
  //   const nextDay = new Date(this.selectedDate);
  //   nextDay.setDate(this.selectedDate.getDate() + 1);
  //   this.selectedDate = nextDay;
  // }

  previousDate() {
    const date = new Date(this.selectedDate);
    date.setDate(date.getDate() - 1);
    this.selectedDate = date;
  }

  nextDate() {
    const date = new Date(this.selectedDate);
    date.setDate(date.getDate() + 1);
    this.selectedDate = date;
  }

  onDateChange(event: any) {
    this.selectedDate = event.value;
  }

  closeClasses() {
    this.router.navigate(['classes']);
  }

  // getstudentattendancelist() {
  //   const dateFormate = this.pipe.transform(this.classesData?.date, 'yyyy-MM-dd');
  //   this.apiservice.getMarkAttendancelist(this.classesData, dateFormate).subscribe((res) => {
  //     this.isLoadingResults = false;
  //     this.isRateLimitReached = res === null;
  //     this.StudentList = new MatTableDataSource<PeriodicElement>(res.rows);
  //   });
  // }

  // getstudentattendanceDetails() {
  //   const dateFormate = this.pipe.transform(this.selectedDate, 'yyyy-MM-dd');
  //   // const dateFormate = this.pipe.transform(this.classesData?.date, 'yyyy-MM-dd');
  //   this.apiservice.getstudentattendanceDetails(this.classesData, dateFormate).subscribe((res) => {
  //     this.studentsattendancedetailschart = res; 
  //     console.log("studentsattendancedetailschart", this.studentsattendancedetailschart)
  //     this.absenteesData = res.absenteesData;
  //     const config: any = {
  //       type: 'doughnut',
  //       data: {
  //         labels: ['Present', 'Absent'],
  //         datasets: [
  //           {
  //             data: [34, 66],
  //             backgroundColor: ['#4CAF50', '#F44336'],
  //             responsive: true,
  //           },
  //         ],
  //       },
  //       options: {
  //         aspectRatio: 1,
  //       },
  //     };
  //     // Chart instial
  //     this.chart = new Chart('MyChart', config);

  //   });
  // }

  loadAttendanceData() {
    const dateFormate = this.pipe.transform(this.selectedDate ?? this.classesData?.date, 'yyyy-MM-dd');

    const sideLabelsPlugin = {
      id: 'sideLabels',
      afterDraw(chart: any) {
        const { ctx } = chart;
        const dataset = chart.data.datasets[0];
        const meta = chart.getDatasetMeta(0);

        ctx.save();
        ctx.font = '12px Arial';
        ctx.fillStyle = '#4b4848ff';

        meta.data.forEach((element: any, index: number) => {
          const count = dataset.data[index];
          const label = chart.data.labels[index];

          const total = dataset.data.reduce((sum: number, val: number) => sum + val, 0);
          const percentage = Math.round((count / total) * 100);

          const text = `${percentage}% (${count})`;

          // Slice position
          const { x, y } = element.tooltipPosition();

          // Side offset
          const offset = 15;
          const textX = x > chart.width / 2 ? x + offset : x - offset;
          const textAlign = x > chart.width / 2 ? 'left' : 'right';

          ctx.textAlign = textAlign;
          ctx.textBaseline = 'middle';
          ctx.fillText(text, textX, y);
        });

        ctx.restore();
      }
    };


    forkJoin({
      list: this.apiservice.getMarkAttendancelist(this.classesData, dateFormate),
      details: this.apiservice.getstudentattendanceDetails(this.classesData, dateFormate)
    }).subscribe(({ list, details }) => {
      // ===== Student List =====
      this.isLoadingResults = false;
      this.isRateLimitReached = list === null;
      this.StudentList = new MatTableDataSource<PeriodicElement>(list.rows);

      // ===== Attendance Details =====
      this.studentsattendancedetailschart = details;
      this.absenteesData = details.absenteesData;
       this.updateDonutChart(details?.presenteesCount, details?.absenteesCount);
      console.log("studentsattendancedetailschart", this.studentsattendancedetailschart)
      const config: any = {
        type: 'doughnut',
        data: {
          labels: ['Present', 'Absent'],
          datasets: [{
            data: [details?.presenteesCount, details?.absenteesCount],
            backgroundColor: ['#4CAF50', '#F44336'],
            borderWidth: 0
          }],
        },
        options: {
          // aspectRatio: 1,
          maintainAspectRatio: false,
          cutout: '65%',
          responsive: true,
          layout: {
            padding: {
              left: 40,
              right: 40
            }
          },
          plugins: {
            legend: {
              display: false,
              position: 'bottom',  // 🔹 legend at bottom
              labels: {
                usePointStyle: true, // small dots instead of rectangles
                pointStyle: 'circle',
                boxWidth: 12,         // dot size
                font: { size: 12, weight: 'bold' },
                color: '#333'
              }
            }
          }
        },
        plugins: [sideLabelsPlugin] // 👈 custom plugin

      };

      setTimeout(() => {
        this.chart = new Chart('MyChart', config);
      });

    });
  }

  // ngAfterViewInit() {
  //   if (this.studentsattendancedetailschart) {
  //     this.createChart(this.studentsattendancedetailschart);
  //   }
  // }

  updateDonutChart(present: number, absent: number) {
    if (this.chart) {
      this.chart.data.datasets[0].data = [present, absent]; // update data
      this.chart.update(); // redraw chart
    }
  }

  createChart(data: any) {
    const config: any = {
      type: 'doughnut',
      data: {
        labels: ['Present', 'Absent'],
        datasets: [{
          data: [
            data.presenteesPercentage,
            data.absenteesPercentage
          ],
          backgroundColor: ['#4CAF50', '#F44336']
        }]
      }
    };

    if (this.chart) {
      this.chart.destroy();
    }

    this.chart = new Chart(this.attendanceChart.nativeElement, config);
  }

  selectioncheckbox(event: any) {
    this.selection.toggle(event);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.StudentList.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows(event: any) {
    if (event === 'ABSENT') {
      this.selection.clear();
      this.StudentList.data.map((res: any) => {
        this.toggleStatus(res, 'ABSENT')
      })
      return;
    } else {
      this.selection.select(...this.StudentList.data);
      this.StudentList.data.map((res: any) => {
        this.toggleStatus(res, 'PRESENT')
      })
    }
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: PeriodicElement): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    } else {
      return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.index + 1}`;
    }
  }

  submitstudentattendance() {
    // let submit_data: any = [];
    // if(this.selection.selected.length !== 0){
    //   submit_data = this.selection.selected.map((student) => ({
    //     ...student,
    //     status: 'Present',
    //   }));
    // }else{
    //   submit_data = this.StudentList.data;
    // }

    // let formattedDate: string = '';

    // if (this.classesData?.date && this.classesData.date !== null && this.classesData.date !== undefined && this.classesData.date !== '') {
    //   const date = new Date(this.classesData.date);
    //   if (!isNaN(date.getTime())) {
    //     formattedDate = this.pipe.transform(this.classesData.date, 'yyyy-MM-dd') || '';
    //   } else {
    //     console.error('Invalid date format in classesData');
    //     formattedDate = new Date().toISOString().split('T')[0];
    //   }
    // } else {
    //   formattedDate = new Date().toISOString().split('T')[0];
    //   console.warn('Date is undefined or null, using current date as fallback');
    // }

    let payload_data = {
      "course_id": this.classesData.course_id,
      "semester_id": this.classesData.semester_id,
      "subject_id": this.classesData.subject_id,
      "section_id": this.classesData.section_id,
      "academic_regulation_id": this.classesData.academic_regulation_id,
      "academic_year_id": this.classesData.academic_year_id,
      "date": this.pipe.transform(this.classesData?.date, 'yyyy-MM-dd') || '',
      "order": this.classesData.order,
      "subject_name": this.classesData.subject_name,
      "start_time": this.classesData.start_time,
      "end_time": this.classesData.end_time,
      "students": this.StudentList.data
    }
    this.createAPi(payload_data);
  }
  createAPi(event: any) {
    this.apiservice.postMarkAttendancelist(event).subscribe(
      (res: any) => {
        if (res.code === 201 && res.status === true) {
          this.loadAttendanceData();
          this.toast.showToast('success', 'Saved Successfully');
        } else {
          // this.toast.showToast('danger', `Error: ${res.message}`);
          this.showToast = true;
        }
      },
      (error) => {
        // this.toast.showToast('warning', error.message);
      }
    );
  }
}


